import { useState } from 'react';
import ru from 'date-fns/locale/ru';
import 'react-day-picker/style.css';
import styles from './styles.module.scss';
import { DayPicker } from 'react-day-picker';
import { Box, Menu, MenuItem } from '@mui/material';
import LoadingButton from 'components/loadingButton';
import { dropDownStyle } from 'components/InitialStyle';
import dayjs from 'dayjs';

type Props = {
  date: any;
  anchorEl: any;
  open: boolean;
  close: () => void;
  setDate: (e: any) => void;
};

export default function RangeComponent({ open, close, anchorEl, date, setDate }: Props) {
  const [state, setState] = useState<any>(date);

  const locale: any = ru;

  function parseDateString(e: any) {
    if (e) {
      const { from, to } = e;
      return {
        from: typeof from === 'string' ? dayjs(from).toDate() : from,
        to: typeof to === 'string' ? dayjs(to).toDate() : to,
      };
    } else {
      return;
    }
  }

  const value = parseDateString(state);

  const onSubmit = () => {
    setDate(value);
    close();
  };

  return (
    <Box>
      <Menu
        anchorEl={anchorEl}
        id='account-menu'
        open={open}
        onClose={close}
        PaperProps={{
          elevation: 0,
          sx: dropDownStyle,
        }}
        transformOrigin={{ horizontal: 'left', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}>
        <MenuItem
          disableRipple
          sx={{
            '&:hover': {
              backgroundColor: '#fff',
            },
            backgroundColor: '#fff',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
          <DayPicker
            captionLayout='dropdown'
            mode='range'
            locale={locale}
            selected={state}
            onSelect={setState}
            className='datepicker'
            showOutsideDays
          />

          <Box className={styles.modalFooter}>
            <LoadingButton variant='cancel' onClick={() => close()}>
              Отменить
            </LoadingButton>
            <LoadingButton type='submit' variant='send' onClick={onSubmit}>
              Выбрать
            </LoadingButton>
          </Box>
        </MenuItem>
      </Menu>
    </Box>
  );
}
